import _ from 'lodash';
import { AxisObj } from '/@services/generated/graphql-types';

export const getColumnsInAxis = (axisProperties: AxisObj[], axisId: string) =>
    _.find(axisProperties, ['id', axisId])?.properties?.linkedColumns || [];

export const getAxisByColumnId = (
    axisProperties: AxisObj[],
    columnId: string,
): AxisObj => {
    return (
        axisProperties.find(axisObj => {
            const axis = axisObj?.properties;
            return _.indexOf(axis.linkedColumns, columnId) >= 0;
        }) || {}
    );
};
